import React from 'react';
import {  Box, Modal,Button,useDisclosure,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Spinner,
    Flex,Input, Image,  Center } from '@chakra-ui/react'
    import Logo from "../../images/rgg_logo2.png"
    import {logInFunc} from '../../util/apiCalls';
    import { useEffect, useState } from 'react';
    import { useToast } from '@chakra-ui/react'
    

const LogIn = ({shouldOpen,onAuthSuccess}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [state, setState] = useState({usr:"",pwd:"",iterator:0});
    const [isAuthenitcating,setIsAuthenticating]=useState(false);
    const toast=useToast();
    useEffect(()=>{
     if (shouldOpen===true) {
      
        onOpen();
     } else {
      onClose();
      
     }
  })

  
const tryLogIn=async ()=>{
  setIsAuthenticating(true);
  let r=await logInFunc(state.usr,state.pwd);
  if (r==="ok") {
    onAuthSuccess();
    toast({
      title:"Prijava uspješna",
      status:"success",
      isClosable:true,
      duration:3000,
      position:"top-right",
  });
  onClose();
  } else {
    //nije uspješno logiranje
    toast({
      title:"Greška kod prijave u aplikaciju",
      status:"error",
      description:r.message,
     //description:"",
      isClosable:true,
      duration:3000,
      position:"top-right",
  });
  }
  setIsAuthenticating(false);
}
  

const handleChange=(e)=>{
  if (e.target.id==="usr") {
    setState({...state,"usr":e.target.value})
  } else {
    setState({...state,"pwd":e.target.value})
  }
}

    return (
        <Box>
        <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}
        scrollBehavior={'inside'} size={'sm'}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Flex direction={'column'}>
                <Center>
                  <Image src={Logo} h={'180px'} w={'300px'} rounded={'sm'}/>
                  
                </Center>
            </Flex>
          </ModalHeader>
          <ModalBody h={'100px'}>
          <Flex direction={'column'} gap={'1rem'}>
            {!isAuthenitcating?
              <>
                <Input focusBorderColor='grunt2.400' size={'sm'} id="usr" onChange={handleChange} variant={'filled'} placeholder='Korisničko ime' maxLength={20} value={state.usr} />
                <Input focusBorderColor='grunt2.400' size={'sm'} id="pwd" onChange={handleChange} variant={'filled'} placeholder='Lozinka' type={'password'} maxLength={20} value={state.pwd} />
              </>
              :
              <Center>
                <Spinner size={'md'}/>
              </Center>
            }
            </Flex>

          </ModalBody>

          <ModalFooter>
            <Button isDisabled={isAuthenitcating} colorScheme='grunt2' mr={3} onClick={tryLogIn} size={'sm'} >
              U redu
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
     
        </Box>
    );
}

export default LogIn;
